import React, { useState } from 'react';
import { Calendar, MapPin, Users, ArrowRight } from 'lucide-react';
import { events } from '../mockData';

const Events = () => {
  const [filter, setFilter] = useState('all');

  const upcomingEvents = events.filter(event => {
    const eventDate = new Date(event.date);
    return eventDate >= new Date();
  });

  const filteredEvents = filter === 'featured' 
    ? upcomingEvents.filter(e => e.featured)
    : upcomingEvents;

  return (
    <div className="page-container events-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="page-hero-bg" 
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1602022578110-fbfad5644f7f?w=1920)' }}
        >
          <div className="page-hero-overlay" />
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Upcoming Events</h1>
          <p className="page-hero-subtitle">
            Join us for powerful worship, inspiring teaching, and meaningful fellowship
          </p>
        </div>
      </section>

      {/* Events Section */}
      <section className="content-section">
        <div className="container">
          {/* Filter Buttons */}
          <div className="filter-buttons">
            <button 
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All Events
            </button>
            <button 
              className={`filter-btn ${filter === 'featured' ? 'active' : ''}`}
              onClick={() => setFilter('featured')}
            >
              Featured
            </button>
          </div>

          {/* Events Grid */}
          <div className="events-grid-full">
            {filteredEvents.map(event => (
              <div key={event.id} className="event-card-full">
                <div className="event-card-image">
                  <img src={event.image} alt={event.title} />
                  {event.featured && (
                    <div className="featured-badge">Featured</div>
                  )}
                </div>
                <div className="event-card-content">
                  <h3 className="event-card-title">{event.title}</h3>
                  
                  <div className="event-meta">
                    <div className="event-meta-item">
                      <Calendar size={18} />
                      <span>{event.date}</span>
                    </div>
                    <div className="event-meta-item">
                      <MapPin size={18} />
                      <span>{event.location}</span>
                    </div>
                  </div>

                  <p className="event-card-description">{event.description}</p>

                  <button className="event-register-btn">
                    Register Now <ArrowRight size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredEvents.length === 0 && (
            <div className="no-events">
              <Users size={48} />
              <p>No events available at this time. Check back soon!</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Stay Updated on Events</h2>
            <p>Follow us on social media to never miss an upcoming event</p>
            <div className="cta-buttons">
              <a 
                href="https://www.facebook.com/people/United-Christian-Fellowship/61571373464756/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Follow on Facebook
              </a>
              <a 
                href="https://www.youtube.com/@UnitedChristianFellowship0" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-secondary"
              >
                Subscribe on YouTube
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;
